import Pusher from 'pusher-js';

// Enable pusher logging - don't include this in production
Pusher.logToConsole = process.env.NODE_ENV === 'development' ? false : false;

var pusher = new Pusher('5c58eba5af49f6348c26', {
  cluster: 'ap1'
});

export default pusher;